import { render, staticRenderFns } from "./IdentificationPhoto.vue?vue&type=template&id=1d1de9e8&scoped=true"
import script from "./IdentificationPhoto.vue?vue&type=script&lang=js"
export * from "./IdentificationPhoto.vue?vue&type=script&lang=js"
import style0 from "./IdentificationPhoto.vue?vue&type=style&index=0&id=1d1de9e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1de9e8",
  null
  
)

export default component.exports